export default __webpack_public_path__ + "static/O0142-f2c793fcd91f8129fdc7f19e50f69b63.png";